// extracted by mini-css-extract-plugin
module.exports = {"enteredHobbies":"hobbies_enteredHobbies__18sif","eachHobby":"hobbies_eachHobby__1sQgz","addingHobby":"hobbies_addingHobby__2rSfJ","addhobby":"hobbies_addhobby__2w8P_"};